import * as React from "react"

import { Col, OverlayTrigger, Popover, Row } from "react-bootstrap"
import { FaArchive } from "react-icons/fa"

import OrderTrackingRowWarning from "./OrderTrackingRowWarning"
import OrderResultRecord from "../../api/OrderResults/OrderResultModel/OrderResultRecord"
import OrderResultRecordIdentifier from "../../api/OrderResults/OrderResultModel/OrderResultRecordIdentifier"
import { ImplementationTypeGovt } from "../../config/Constants"
import Checkbox from "../Checkbox"

export interface OrderTrackingCheckboxProps {
  idPrefix: string
  item: OrderResultRecordIdentifier
  row: OrderResultRecord
  implementationType: string
  checked: boolean
  disabled: boolean
  onChange: (item: OrderResultRecordIdentifier, checked: boolean) => void
}

function OrderTrackingCheckbox({
  idPrefix,
  item,
  row,
  implementationType,
  checked,
  disabled,
  onChange,
}: OrderTrackingCheckboxProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => onChange(item, e.target.checked)

  return (
    <Row>
      <Col className="d-flex justify-content-center align-items-center p-0">
        {implementationType !== ImplementationTypeGovt}
      </Col>
      <Col className="d-flex justify-content-center align-items-center p-0">
        <Checkbox
          id={`${idPrefix}_${item.TestDetailID}_${item.TestDetailClinicalID}`}
          className="mt-1"
          checked={checked}
          disabled={disabled}
          onChange={handleChange}
        />
      </Col>
      <Col className="d-flex justify-content-center align-items-center p-0">
        {item.Archived && (
          <OverlayTrigger
            placement="top-start"
            delay={{ show: 100, hide: 400 }}
            overlay={
              <Popover id="is_archived" className="bg-light">
                <Popover.Content>The sample is archived.</Popover.Content>
              </Popover>
            }
          >
            <FaArchive className="icon icon-archived" />
          </OverlayTrigger>
        )}
      </Col>
    </Row>
  )
}

export default OrderTrackingCheckbox
